<template>
  <div ref="containerRef" class="tw:md:hidden tw:ml-6 tw:overflow-x-clip">
    <div
      ref="inner"
      class="tw:whitespace-nowrap tw:transition-transform tw:duration-1000 tw:grid tw:grid-flow-col tw:auto-cols-[300px] tw:gap-4"
      :style="innerStyles"
    >
      <StudioPlusBenefitsCardMobile v-for="item in cards" :key="item.id" :id="item.id" :item="item" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import TouchEvent from '@/utils/touchEvents.ts'

import StudioPlusBenefitsCardMobile from '@/components/productPage/studioPlus/benefits/StudioPlusBenefitsCardMobile.vue'

const emit = defineEmits(['onCardChanged'])

defineProps({
  cards: {
    type: Array,
    required: true,
  },
})

const CARD_WIDTH = 300
const GAP = 16
const SLIDE_SIZE = CARD_WIDTH + GAP

const containerRef = ref(null)
const touchEvent = ref(null)
const inner = ref(null)
const innerStyles = ref({})
const transitioning = ref(false)
const timer = ref(null)

const moveLeft = () => {
  innerStyles.value = {
    transition: 'transform 1s ease',
    transform: `translateX(-${SLIDE_SIZE}px)`,
  }
}

const moveRight = () => {
  innerStyles.value = {
    transition: 'transform 1s ease',
    transform: `translateX(${SLIDE_SIZE}px)`,
  }
}

const resetTranslate = () => {
  innerStyles.value = {
    transition: 'none',
    transform: 'translateX(0)',
  }
}

const afterTransition = callback => {
  const listener = () => {
    callback()
    inner.value?.removeEventListener('transitionend', listener)
  }
  inner.value?.addEventListener('transitionend', listener)
}

const next = () => {
  if (transitioning.value) return
  transitioning.value = true

  moveLeft()
  afterTransition(() => {
    const firstElement = inner.value?.firstElementChild
    if (firstElement) {
      inner.value.appendChild(firstElement)
    }

    updateCurrent()
    resetTranslate()
    transitioning.value = false
  })
}

const prev = () => {
  if (transitioning.value) return
  transitioning.value = true

  moveRight()
  afterTransition(() => {
    const lastElement = inner.value?.lastElementChild
    if (lastElement) {
      inner.value.prepend(lastElement)
    }

    updateCurrent()
    resetTranslate()
    transitioning.value = false
  })
}

const updateCurrent = () => {
  const firstElementId = inner.value?.firstElementChild?.id
  emit('onCardChanged', { id: firstElementId })
}

const handleSwipe = event => {
  if (!touchEvent.value) return

  touchEvent.value.setEndEvent(event)

  if (touchEvent.value.isSwipeRight()) {
    prev()
  } else if (touchEvent.value.isSwipeLeft()) {
    next()
  }

  touchEvent.value = null
}
const handleTouchStart = event => {
  touchEvent.value = new TouchEvent(event)
}

const autoplay = () => {
  timer.value = setInterval(() => {
    next()
  }, 5000)
}

onMounted(() => {
  autoplay()
  containerRef.value?.addEventListener('touchstart', handleTouchStart)
  containerRef.value?.addEventListener('touchend', handleSwipe)
})

onBeforeUnmount(() => {
  clearInterval(timer.value)
  containerRef.value?.removeEventListener('touchstart', handleTouchStart)
  containerRef.value?.removeEventListener('touchend', handleSwipe)
})
</script>
